import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import { defaultSplit } from "./ConfigDefault";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

const ConfigNoSplit: React.FC = () => {
  const { setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();
  return (
    <>
      <Typography className="italic">
        Un découpage vous aide à séparer différents documents présents dans un
        même fichier.
        <br />
        Il fonctionne en classifiant chaque page puis en regroupant les pages
        successives appartenant à un même document.
      </Typography>

      <div className="flex justify-center">
        {!isReadOnly && (
          <Button
            variant="contained"
            onClick={() => setValue("config.split", defaultSplit())}
            className="gap-2"
          >
            <Add />
            Découpage
          </Button>
        )}
      </div>
    </>
  );
};
export default ConfigNoSplit;
